import { METHOD } from './method'

export const API_SOP_CATEGORY = {
    LIST: {
        api: '/v1/hr-adm/sop/categories',
        method: METHOD.GET,
    },
    CREATE: {
        api: '/v1/hr-adm/sop/category',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/hr-adm/sop/category',
        method: METHOD.PUT,
    },
    DELETE: {
        api: '/v1/hr-adm/sop/category/delete',
        method: METHOD.POST,
    },
}
